module.exports = (__webpack_require__(16))(70);